export default __webpack_public_path__ + "static/media/directory-icon.b384d15c.svg";